import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import getters from './getters';
import app from './modules/app';
import settings from './modules/settings';
// eslint-disable-next-line import/no-cycle
import user from './modules/user';
// eslint-disable-next-line import/no-cycle
import projects from './modules/projects';
// eslint-disable-next-line import/no-cycle
import systemManage from './modules/systemManage';
import svgEditor from './modules/svgEditor';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    projects,
    systemManage,
    svgEditor,
  },
  getters,
  plugins: [createPersistedState()],
});

export default store;
